export default {
  STEP_IN_MINUTES: 10,
  DEFAULT_HOUR: 7,
};
